import { ConfiguratorUIElementStates, ConfiguratorUIElementWithChildrenState } from '@/stores/CfgUIElementState';

import React, { CSSProperties } from 'react';

import { IUiCfgContainer } from '@canvas-logic/clp-api-types';
import { ComponentsContainerCfgUIElement } from '@/UiBuilder/elements/ComponentsContainerCfgUIElement/ComponentsContainerCfgUIElement';

let id = 0;

export class ComponentsContainerCfgUIElementState extends ConfiguratorUIElementWithChildrenState {
  constructor(children: Array<ConfiguratorUIElementStates>, viewElement: IUiCfgContainer) {
    super(children, viewElement);
  }

  render(): React.ReactElement {
    let style: CSSProperties = {};

    return (
      <ComponentsContainerCfgUIElement
        childrenElements={this.children}
        viewElement={this.viewElement}
        key={this.viewElement.id}
      />
    );
  }
}
